import React from 'react';
import { PropTypes } from 'prop-types';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

/* eslint-disable max-len */
// eslint-disable-next-line import/prefer-default-export
export const RtkActionsCellRenderer = ({
  value: id,
  data: item,
  node,
  context: { permissions, takeItem }
}) => (
  <div>
    <div className="rtk-action-btn-group">
      <AccessControl
        permissions={ permissions }
        allowedPermissions={ [ActivityPerms.cicwfInitialReviewer, ActivityPerms.cicwfSecondaryReviewer, ActivityPerms.cicwfExpertReviewer, ActivityPerms.cicwfSupplReviewer] }
      >
        <button
          type="button"
          title="View RtK/CiC Decision"
          rel="noopener noreferrer"
          className="btn btn-sm btn-action"
          onClick={ () => takeItem(item) }
        >
          <span className="icon icon-apps" />
        </button>
      </AccessControl>
    </div>
  </div>
);

RtkActionsCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  data: PropTypes.shape({
    formType: PropTypes.string,
    isOnlineForm: PropTypes.bool
  }).isRequired,
  node: PropTypes.shape({}).isRequired,
  context: PropTypes.shape({
    permissions: PropTypes.arrayOf(PropTypes.string),
    takeItem: PropTypes.func,
    openRtkDecisionCallback: PropTypes.func,
  })
};

RtkActionsCellRenderer.defaultProps = {
  context: {}
};
